import { MenuItemInfo } from '@tableau/widgets';
import React from 'react';

import { Messages } from '../../../codegen/Localize';
import { FlowOutputStepInfo } from '../../models/FlowOutputStepInfo';
import { RunFlowSubMenuItemStyles as styles } from '../../styles/RunFlowSubMenuItemStyles';
import { getRefreshTypeDisplayText } from '../../utils/FlowOutputStepUtils';

export type RunFlowSubMenuItemProps = {
  readonly iconStyle?: React.CSSProperties;
  readonly isDefault?: boolean;
  readonly displayText: string;
  readonly helpText: string;
};

// Menu item for refresh types
export class RunFlowSubMenuItem extends React.PureComponent<RunFlowSubMenuItemProps> {
  public render(): JSX.Element {
    return (
      <div className={styles.root}>
        {this.props.iconStyle && <div style={this.props.iconStyle} className={styles.subMenuIcon} />}
        <div className={styles.subMenuText}>{this.props.displayText}</div>
        {this.props.isDefault && <div className={styles.defaultText}>{Messages.writeOptionsDefault()}</div>}
        <div className={styles.subMenuHelpText}>{this.props.helpText}</div>
      </div>
    );
  }

  public toString(){
    return  this.props.displayText;
  }
}

//// Pre-configued menu items for dropdown list
export const writeOptionsRunAllDefault = () =>
  <RunFlowSubMenuItem displayText={Messages.writeOptionsRunAllDefault()} helpText={Messages.writeOptionsDefaultHelpText()} />;

export const writeOptionsRunAllFull = (isDefault: boolean = true) =>
  <RunFlowSubMenuItem displayText={Messages.writeOptionsFull()} isDefault={isDefault} helpText={Messages.writeOptionsFullHelpText()} />;

export const writeOptionsRunAllIncremental = () =>
  <RunFlowSubMenuItem displayText={Messages.writeOptionsIncremental()}
    helpText={Messages.writeOptionsIncrementalHelpText() + Messages.writeOptionsFallbackHelpText()} />;

export const writeOptionsFull = (step: FlowOutputStepInfo, isDefault: boolean = true) =>
  <RunFlowSubMenuItem
    displayText={getRefreshTypeDisplayText(false, step.outputOperationType)}
    isDefault={isDefault}
    helpText={Messages.writeOptionsFullHelpText()} />;

export const writeOptionsIncremental = (step: FlowOutputStepInfo) =>
  <RunFlowSubMenuItem
    displayText={getRefreshTypeDisplayText(true, step.incrementalOutputOperationType)}
    isDefault={step.isIncrementalDefault}
    helpText={Messages.writeOptionsIncrementalHelpText() + Messages.writeOptionsBundleHelpText()} />;

//// Similar to the above but as MenuItemInfo
export const writeOptionsRunAllFullMenuItemInfo = (isDefault: boolean = true): MenuItemInfo => {
  return {
    annotation: isDefault ? Messages.writeOptionsDefault() : undefined,
    detail: Messages.writeOptionsFullHelpText(),
    displayValue: Messages.writeOptionsFull(),
  };
};

export const writeOptionsRunAllIncrementalMenuItemInfo = (): MenuItemInfo => {
  return {
    detail: Messages.writeOptionsIncrementalHelpText() + Messages.writeOptionsFallbackHelpText(),
    displayValue: Messages.writeOptionsIncremental(),
  };
};

export const writeOptionsFullMenuItemInfo = (step: FlowOutputStepInfo, isDefault: boolean = true): MenuItemInfo => {
  return {
    annotation: isDefault ? Messages.writeOptionsDefault() : undefined,
    detail: Messages.writeOptionsFullHelpText(),
    displayValue: getRefreshTypeDisplayText(false, step.outputOperationType),
  };
};

export const writeOptionsIncrementalMenuItemInfo = (step: FlowOutputStepInfo): MenuItemInfo => {
  return {
    annotation: step.isIncrementalDefault ? Messages.writeOptionsDefault() : undefined,
    detail: Messages.writeOptionsIncrementalHelpText() + Messages.writeOptionsBundleHelpText(),
    displayValue: getRefreshTypeDisplayText(true, step.incrementalOutputOperationType),
  };
};
